@if (true) {
    <div class="modal-body">
        <form [formGroup]="NotificationEntry" (ngSubmit)="onNotificationSubmit(NotificationEntry.value);">
        <div class="card">
            <div class="card-body">
                    <div class="row">
                        <div class="col-auto col-sm-3 mt-3">Module</div>
                        <div class="col-auto col-sm-9 mt-3">
                            <input type="hidden" [formControlName]="'ID'" [(ngModel)]="this.id" />
                            <input type="hidden" [formControlName]="'UserDataID'" [(ngModel)]="this.userDataId" /> {{this.NotificationData.ModuleDs}}
                        </div>  
                        <div class="col-auto col-sm-3 mt-3">Feature</div>
                        <div class="col-auto col-sm-9 mt-3">{{this.NotificationData.FeatureDs}}</div>
                        <div class="col-12 col-sm-6 mt-3">
                            <div class="form-group">
                                <label for="Employee">Employee</label>
                                <ng-select [items]="UserMasterDetail" [clearable]="false" [multiple]="false" [formControlName]="'Employee'" bindLabel="UserName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID" [(ngModel)]="this.NotificationData.UserID">
                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                        {{item.UserName}} &nbsp; &nbsp;{{item.Email}}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-auto col-sm-6 mt-3">
                            <div class="form-group">
                                <label for="NonUser">Non User</label>
                                <input type="text" class="form-control" [formControlName]="'NonUser'"  placeholder="Enter Email (,)"/>
                            </div>
                        </div>
                        <div class="col-auto col-sm-6 ">
                            <div class="form-group">
                                <label> Send Email To</label>
                                <ng-select [items]="UserMasterDetail" [clearable]="false" [multiple]="true" [formControlName]="'EmailManager'" bindLabel="UserName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID" [(ngModel)]="this.NotificationData.EmailEmployee">
                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                        {{item.UserName}} &nbsp; &nbsp;{{item.Email}}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-auto col-sm-6 ">
                            <div class="form-group">
                                <label> Send SMS To</label>
                                <ng-select [items]="UserMasterDetail" [clearable]="false" [multiple]="true" [formControlName]="'SMSManager'" bindLabel="UserName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID" [(ngModel)]="this.NotificationData.SMSEmployee">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    {{item.UserName}} &nbsp; &nbsp;{{item.Email}}
                                </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center mt-3">
                <button class="btn btn-primary submit-btn small " type="submit">
                    Save
                </button>   
            </div>
        </form>
    </div>
}@else {
    <!-- <div class="modal-body  col-sm-12 form-group">
        <form [formGroup]="NotificationEntry" (ngSubmit)="onNotificationSubmit(NotificationEntry.value);">
    
            <div class="col-sm-4 height-34">Module</div>
            <div class="col-sm-5 height-34">
                <input type="hidden" [formControlName]="'ID'" [(ngModel)]="this.id" />
                <input type="hidden" [formControlName]="'UserDataID'" [(ngModel)]="this.userDataId" /> {{this.NotificationData.ModuleDs}}
            </div>
            <div class="col-sm-3">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34">Feature</div>
            <div class="col-sm-5 height-34">{{this.NotificationData.FeatureDs}}</div>
            <div class="col-sm-3">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34">Employee</div>
            <div class="col-sm-5" style="padding-top:5px;">
                <ng-select [items]="UserMasterDetail" [clearable]="false" [multiple]="false" [formControlName]="'Employee'" bindLabel="UserName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID" [(ngModel)]="this.NotificationData.UserID">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        {{item.UserName}} &nbsp; &nbsp;{{item.Email}}
                    </ng-template>
                </ng-select>
            </div>
            <div class="col-sm-3">&nbsp;</div>
    
            <div class="col-sm-4 height-34">Non User</div>
            <div class="col-sm-5" style="padding-top:5px;">
                <input type="text" class="form-control" [formControlName]="'NonUser'"  placeholder="Enter Email (,)"/>
            </div>
            <div class="col-sm-3">&nbsp;</div>
    
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34">Send Email To</div>
            <div class="col-sm-5" style="padding-top:5px;">
                <ng-select [items]="UserMasterDetail" [clearable]="false" [multiple]="true" [formControlName]="'EmailManager'" bindLabel="UserName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID" [(ngModel)]="this.NotificationData.EmailEmployee">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        {{item.UserName}} &nbsp; &nbsp;{{item.Email}}
                    </ng-template>
                </ng-select>
            </div>
            <div class="col-sm-3">&nbsp;</div>
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-4 height-34">Send SMS To</div>
            <div class="col-sm-5" style="padding-top:5px;">
                <ng-select [items]="UserMasterDetail" [clearable]="false" [multiple]="true" [formControlName]="'SMSManager'" bindLabel="UserName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID" [(ngModel)]="this.NotificationData.SMSEmployee">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        {{item.UserName}} &nbsp; &nbsp;{{item.Email}}
                    </ng-template>
                </ng-select>
            </div>
            <div class="col-sm-3">&nbsp;</div>
    
            <div class="col-sm-12">
                <hr>
            </div>
    
            <div class="col-sm-12">&nbsp;</div>
    
            <div class="col-sm-4">&nbsp;</div>
            <div class="col-sm-5"><input class="btn btn-primary" type="submit" value="Save"></div>
            <div class="col-sm-3"></div>
            <div class="form-group mt-2" style="display:none;">
                <div class="form-check">
                    <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true [(ngModel)]="options.autoClose">
                    <label for="autoClose">Auto close alert after three seconds</label>
                </div>
    
            </div>
            <div class="jumbotron p-4">
                <div class="container text-center col-sm-4 alertCss">
                    <app-alert></app-alert>
                    <router-outlet></router-outlet>
                </div>
            </div>
    
        </form>
    </div> -->
}
